import styled from 'styled-components'

export const Main = styled.div`
  box-sizing: border-box;
  padding-bottom: ${({ paddingBottom }) => paddingBottom || '0'};
  padding-top: ${({ paddingTop }) => paddingTop || '0'};
  padding-left: ${({ paddingLeft }) => paddingLeft || '1rem'};
  padding-right: ${({ paddingRight }) => paddingRight || '1rem'};
  width: 100%;
`

export const Chip = styled.div`
  align-items: center;
  background: ${props => props.bg};
  color: ${props => props.fg || '#000'};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  height: 26px;
  width: ${props => props.width || '26px'};
`

export const Cursor = styled.div`
  display: ${(props) => (props.block ? 'block' : 'inline')};
  cursor: ${(props) => props.name || 'pointer'};
`

export const Margin = styled.div`
  margin-top: ${(props) => props.top || 'auto'};
  margin-bottom: ${(props) => props.bottom || 'auto'};
  margin-left: ${(props) => props.left || 'auto'};
  margin-right: ${(props) => props.right || 'auto'};
`

export const MarginBottom = styled.div`
  margin-bottom: ${(props) => props.value};
`

export const MarginRight = styled.div`
  margin-right: ${(props) => props.value};
  display: ${(props) => (props.block ? 'block' : 'inline-block')};
`

export const MarginTop = styled.div`
  margin-top: ${(props) => props.value};
`

export const MarginLeft = styled.div`
  margin-left: ${(props) => props.value};
`

export const Padding = styled.div`
  padding: ${(props) => props.value};
`

export const Relative = styled.div`
  bottom: ${(props) => props.bottom || 'auto'};
  position: relative;
  left: ${(props) => props.left || 'auto'};
  right: ${(props) => props.right || 'auto'};
  top: ${(props) => props.top || 'auto'};
`

export const Box = styled.div`
  ${({ theme, background }) =>
    background && theme
      ? `background: ${theme.palette[background]?.main}; color: ${theme.palette[background]?.contrastText};`
      : ''}
  display: ${(props) => props.display || 'flex'};
  flex-direction: ${(props) => props.direction || 'column'};
  gap: ${(props) => props.gap || 'auto'};
  align-items: ${(props) => props.align || 'flex-start'};
  justify-content: ${(props) => props.justify || 'flex-start'};
  width: ${(props) => props.width || 'auto'};
  padding: ${(props) => props.pad || '0'};
  margin: ${(props) => props.margin || '0'};
  flex-grow: ${(props) => props.grow || '0'};
  flex-basis: ${(props) => props.basis || 'auto'};
  box-sizing: ${(props) => props.borderBox ? 'border-box' : 'content-box'};
`

export const MarkdownContainer = styled.div`
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }

  table th {
    border: 1px solid ${({ theme }) => theme.palette.contrastLight.main};
    font-size: bold;
    padding: .5rem;
  }

  table td {
    border: 1px solid ${({ theme }) => theme.palette.contrastLight.main};
    padding: .5rem;
  }

  a {
    color: #bd6264;
  }
`
